export default {
  views: {
    list: {
      index: {
        "view_title": "Homologacije",
        "status": "Status",
        "note": "Opomba",
        "vehicle": "Vozilo",
        "vin_number": "VIN številka",
        "towbar_code": "Koda kljuke",
        "delete": "Izbriši",
        "remove_homologation": "Izbriši homologacijo",
        "youre_about_to_delete_homologation_would_you_like_to_proceed_with_this_action": "Ste prepričani, da želite izbrisati homologacijo?",
        "cancel": "Prekliči",
        "homologation_successfully_deleted": "Homologacija je uspešno izbrisana"
      }
    }
  }
}
